export enum PublishState {
  Unpublished,
  Pending,
  Published,
}
